// Shared architectural details. All parts merge into the building's single mesh.
import { MeshBuilder } from './mesh'
import { MAT } from './palette3d'

/** Overlapping roof courses, dark eaves and a carved ridge cap. */
export function roof(mb: MeshBuilder, x: number, y: number, z: number, w: number, h: number, d: number, color: string): void {
  mb.gable(x, y, z, w, h, d, MAT.woodDk)
  for (let i = 0; i < 4; i++) {
    const low = i / 4, high = (i + 1) / 4
    for (const side of [-1, 1]) {
      const a = [x + side * (w / 2 * (1 - low) + 0.6), y + h * low + 0.65, z - d / 2]
      const b = [a[0], a[1], z + d / 2]
      const c = [x + side * w / 2 * (1 - high), y + h * high + 0.65, z + d / 2]
      const e = [c[0], c[1], z - d / 2]
      if (side < 0) mb.quad(a, b, c, e, color, 0.94 + (i % 2) * 0.06)
      else mb.quad(b, a, e, c, color, 0.94 + (i % 2) * 0.06)
      mb.box(a[0], a[1] - 0.3, z, 0.7, 0.65, d, color)
    }
  }
  mb.box(x, y + h + 1.1, z, 2, 1.8, d + 2, MAT.timber)
  for (const side of [-1, 1]) {
    mb.box(x + side * w / 2, y, z, 1.5, 1.8, d + 1, MAT.woodDk)
    for (const end of [-1, 1]) mb.beam([x + side * w / 2, y, z + end * d / 2], [x, y + h, z + end * d / 2], 1.4, MAT.woodPale)
  }
}

/** Recessed amber window with shutters and a projecting sill; faces -Z. */
export function windowDetail(mb: MeshBuilder, x: number, y: number, z: number, w = 5, h = 6): void {
  mb.box(x, y, z, w + 1.6, h + 1.6, 1, MAT.timber)
  mb.box(x, y, z - 0.6, w, h, 0.5, '#dba968')
  mb.box(x, y, z - 1, 0.7, h, 0.5, MAT.woodDk)
  mb.box(x, y, z - 1, w, 0.7, 0.5, MAT.woodDk)
  for (const side of [-1, 1]) mb.box(x + side * (w / 2 + 1.5), y, z - 0.3, 1.7, h + 0.7, 0.9, MAT.wood)
  mb.box(x, y - h / 2 - 1, z - 0.8, w + 3.5, 1.1, 2.5, MAT.woodPale)
}

export function barrel(mb: MeshBuilder, x: number, y: number, z: number, r = 3, h = 7): void {
  mb.cyl(x, y, z, r, h, 8, MAT.wood)
  for (const t of [0.15, 0.78]) mb.cyl(x, y + h * t, z, r + 0.2, 0.8, 8, MAT.metalDk)
  mb.box(x, y + h + 0.1, z, r * 1.7, 0.4, 0.7, MAT.woodPale)
}

export function pennant(mb: MeshBuilder, x: number, y: number, z: number, color: string): void {
  mb.cyl(x, y, z, 0.55, 12, 5, MAT.woodDk)
  mb.gem(x, y + 12.5, z, 1.6, 2, 1.6, MAT.gold)
  mb.quad([x, y + 11, z], [x + 7, y + 10, z + 0.7], [x + 6, y + 5, z + 0.7], [x, y + 6, z], color)
}
